'use client';

import { Link as UiLink } from '@mui/material';
import { env } from '@repo/env';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType } from '@repo/segment/enums';
import { EntityPlacementCtaTypeEnum } from '@repo/supergraph/marketplace/enums';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../..';
import { useProductCardBottomLineContext } from '../../../roundups/components/ProductCard/OurTake/ProductCardBottomLineContext';

export type LinkProps = StructuredContentDocument<{
  href?: string;
  target?: string;
  children: StructuredContentDocument;
}>;

export const Link = ({ props }: LinkProps) => {
  const { isWithinProductCardBottomLine, ctaData } = useProductCardBottomLineContext();

  return (
    <>
      {[props.children].flat().map((child, idx) => {
        if (typeof child === 'string') {
          if (
            isWithinProductCardBottomLine &&
            props.href?.includes(`${env.NEXT_PUBLIC_NW_URL}/redirect/`) &&
            ctaData?.cta &&
            ctaData?.ctaAnalytics
          ) {
            return (
              <CtaLink
                key={idx}
                cta={{
                  ...ctaData.cta,
                  type: EntityPlacementCtaTypeEnum.RestOfProductCard,
                }}
                monetizable={ctaData.ctaAnalytics.monetizable}
                analyticsPayload={{
                  ...ctaData.ctaAnalytics,
                }}
                linkType={LinkType.REST_OF_PRODUCT_CARD}
              >
                {child}
              </CtaLink>
            );
          }

          return (
            <UiLink key={idx} href={props.href} target={props.target}>
              {child}
            </UiLink>
          );
        }

        if (!child) {
          return null;
        }

        return (
          <UiLink key={idx} href={props.href} target={props.target}>
            <StructuredContentRenderer doc={child} key={idx} />
          </UiLink>
        );
      })}
    </>
  );
};
